export const MODAL_REQUEST_TYPES = {
  renameFile: 'renameFile',
  renameFolder: 'renameFolder',
  moveFile: 'moveFile',
  moveFolder: 'moveFolder',
  replaceFile: 'replaceFile',
  partitionFolder: 'partitionFolder'
};